// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37JBK","icon":"styles_icon__1ENhZ"};